import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class AnalyticsChartModel extends BaseModel {
  static urlPath = "analytics";

  // Stores the raw API payload for dynamic chart rendering.
  @attr("json") raw;

  static assignAttributes(obj, attrs) {
    super.assignAttributes(obj, attrs);
    obj.raw = attrs ?? null;
  }
}


